const NoStudentAccountAccessPage = () => {
  return (
    <div className="w-75 mx-auto mt-4 text-start border border-secondary rounded p-3">
        <p>
            Your subscription does not currently include access to a separate student account. 
            If you would like to upgrade your subscription, please proceed to the <a href="/subscribe">subscribe</a> page, or contact us at <a href="mailto:sales@stemsims.com">sales@stemsims.com</a>.
        </p>
    </div>
  )
}

export default NoStudentAccountAccessPage
